import { isValidEmail } from '@rsos/utils/validators';

/** Error shown on a recipient tag that isn't a valid email address. */
export const EMAIL_ONLY_RECIPIENT_ERROR = 'Enter a valid email address';

/**
 * Field Sharing is email-only. Flags any recipient tag whose value isn't a
 * valid email address (phone numbers, malformed addresses) as invalid with an
 * error so it can't be submitted and renders as an error tag. Valid-email tags
 * pass through unchanged.
 *
 * Generic over the tag shape so both the create flow (FieldShare) and the
 * edit flow (EventShareCard) can share a single source of truth.
 */
export const markEmailRecipientValidity = <
  T extends { value: string; isValid: boolean; error?: string },
>(
  tags: T[],
): T[] =>
  tags.map(
    (tag): T =>
      isValidEmail(tag.value)
        ? tag
        : { ...tag, isValid: false, error: EMAIL_ONLY_RECIPIENT_ERROR },
  );
